<template>
  <base-select
    size="sm"
    :shadow="false"
    :options="options"
    v-model="selected"
    @change="onChange"
  />
</template>

<script>
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  props: {
    officeBanks: Array,
    value: null,
    paymentMethodId: String,
  },
  emits: ['input', 'change'],
  computed: {
    options() {
      return [
        {
          key: 'null',
          value: null,
          label: 'Pilih Bank',
          disabled: true,
        },
        ...this.officeBanks.map((item) => ({
          key: item.id,
          value: item.id,
          label: item.attributes.bank_name,
        })),
      ];
    },
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async onChange() {
      await this.$nextTick();

      const selectedBank = this.officeBanks.find(
        (bank) => bank.id === this.selected
      );

      this.$emit('change', selectedBank);
    },
  },
};
</script>
